/**
 * Router principal da aplicação
 */

import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import App from './App';
import { DashboardOperacional } from './components/dashboard';

function AppRouter() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Rota do Dashboard */}
        <Route path="/dash" element={<DashboardOperacional />} />
        
        {/* Rota principal - Mapa */}
        <Route path="*" element={<App />} />
      </Routes>
    </BrowserRouter>
  );
}

export default AppRouter;
